export default __webpack_public_path__ + "static/media/user-icon.9d6090d8.svg";